<template>
  <div v-if="showComponent && onReady" :key="componentRefresh">
    <single-select-field
        :ref="`ks-campaign-single-select-field-${_uid}`"
        v-if="type == 'basic'"
        :customStyle="customStyle"
        :inlineSelectColClass="inlineSelectColClass"
        :readOnly="readOnly"
        :slotOptionLabel="slotOptionLabel"
        :enableSearch="enableSearch"
        :tooltip="tooltip"
        :tooltipIcon="tooltipIcon"
        :tooltipRight="tooltipRight"
        :tooltipLeft="tooltipLeft"
        :inLine="inLine"
        :inlineLabelColClass="inlineLabelColClass"
        :classes="classes"
        :label="label"
        :options="options"
        :required="required"
        :disabled="disabled||!enableComponent"
        :optionValue="optionValue"
        :optionLabel="optionLabel"
        :optionFilter="optionFilter"
        :size="size"
        :showAllOption="options.length > 1 ? showAllOption : false"
        :allOptionLabel="allOptionLabel"
        :allOptionValue="allOptionCampaigns"
        :showNewOption="showNewOption"
        :newOptionLabel="newOptionLabel"
        :showNullOption="showNullOption"
        :nullOptionLabel="nullOptionLabel"
        v-model="input"
        @onMounted="selectorMounted"
        @onClick="onClick"
        @onChange="onChange"
        @onFocus="onFocus"
        @onBlur="onBlur"
        @onkeypress="onKeyPress"
        @onAllClick="onAllClick"
        @onNewClick="onNewClick"
    />

    <custom-single-select-field
        :ref="`ks-campaign-single-select-field-${_uid}`"
        v-if="type == 'custom'"
        :optionPlaceholder="optionPlaceholder"
        :optionNodes="optionNodes"
        :enableSearch="enableSearch"
        :parentId="parentId"
        :childId="childId"
        :maxHeight="maxHeight"
        :tooltip="tooltip"
        :tooltipIcon="tooltipIcon"
        :tooltipRight="tooltipRight"
        :tooltipLeft="tooltipLeft"
        :inLine="inLine"
        :inlineLabelColClass="inlineLabelColClass"
        :label="label"
        :options="options"
        :required="required"
        :disabled="disabled||!enableComponent"
        :optionValue="optionValue"
        :optionLabel="optionLabel"
        :optionFilter="optionFilter"
        :size="size"
        :showAllOption="options.length > 1 ? showAllOption : false"
        :allOptionLabel="allOptionLabel"
        :allOptionValue="allOptionCampaigns"
        :showNewOption="showNewOption"
        :newOptionLabel="newOptionLabel"
        :showNullOption="showNullOption"
        :nullOptionLabel="nullOptionLabel"
        :validation="validation"
        :validationOnChange="validationOnChange"
        :helpText="helpText"
        :enableTree="enableTree"
        v-model="input"
        @onMounted="selectorMounted"
        @onChange="onChange"
    />
  </div>
</template>

<script>
import Vuex from 'vuex';
import checkPermissions from '../../../mixins/checkPermissions';
import dataproviderOptionsValidation from './../mixins/index.js';
import custom_single_select_field from './../selector-types/custom-single-select-field';
import single_select_field from './../selector-types/single-select-field';

export default {
  name: "ks-campaign-single-select",
  mixins: [checkPermissions, dataproviderOptionsValidation],
  components: {
    'custom-single-select-field': custom_single_select_field,
    'single-select-field': single_select_field
  },
  props: {
    dataSource: {type: String, default: null},
    type: {type: String, default: 'basic'},
    selectCampaignIfSingleCampaignMode: {type: Boolean, default: true},
    defaultValue: {},
    validation: {type: Function, default: null},
    validationOnChange: {type: Boolean, default: false},
    helpText: {type: String, default: null},
    optionPlaceholder: {type: String, default: ''},
    optionNodes: {type: String, default: null},
    enableSearch: {type: Boolean, default: false},
    maxHeight: {type: String, default: "650px"},
    tooltip: {type: String, default: null},
    tooltipIcon: {type: String, default: 'fas fa-question-circle'},
    tooltipRight: {type: Boolean, default: false},
    tooltipLeft: {type: Boolean, default: true},
    index: {type: Number},
    inLine: {type: Boolean, default: false},
    inlineLabelColClass: {type: String, default: 'col'},
    label: {type: String, default: 'Campaign'},
    setToDefaultCampaign: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    optionFilter: {default: null}, //function to filter
    size: {type: String, default: null},//sm-lg-md
    showAllOption: {type: Boolean, default: false},
    allOptionLabel: {type: String, default: "All"},
    allOptionValue: {type: String, default: null},
    showNewOption: {type: Boolean, default: false},
    newOptionLabel: {type: String, default: "New"},
    showNullOption: {type: Boolean, default: false},
    nullOptionLabel: {type: String, default: "None"},
    returnType: {type: String, default: null},
    enableCampaignOptionIfHasPermission: {
      type: Array, default: function () {
        return []
      }
    },
    /* aditional props single selector  */
    inlineSelectColClass: {type: String, default: 'col'},
    readOnly: {type: Boolean, default: false},
    slotOptionLabel: {type: Boolean, default: false},
    customStyle: {type: String, default: null},
    classes: {type: String, required: false}

  },
  watch: {
    defaultValue: function (val, oldVal) {
      this.input = this.defaultValue;
    },
    selected_campaigns: {
      handler: function (val) {
        if (val.length === 1) {
          if (this.enableCampaignOptionIfHasPermission.length > 0) {
            if (app.auth.user.hasPermission(this.enableCampaignOptionIfHasPermission, [val[0].id])) {
              this.input = val[0].id;
            } else {
              this.input = null;
            }

          } else {

            this.input = val[0].id;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    ...Vuex.mapGetters({selected_campaigns: 'rms_ui/auth/selected_campaigns'}),
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.dataSource == null) return this.l_input;
        let l_input_data = this.$parent.data_provider_ref[this.inputType];
        let l_input_value = this.$parent.data_provider_ref[this.inputType][this.dataSource];
        if (this.inputType === 'list') {
          return l_input_data[this.index][this.dataSource];
        }
        if (this.returnType === "string") {
          return l_input_value ? l_input_value.toString() : '';
        }
        return l_input_value;
      },
      set(newval) {
        if (this.dataSource !== null) {
          let l_input_list_value = this.$parent.data_provider_ref[this.inputType][this.index];
          let l_input_value = this.$parent.data_provider_ref[this.inputType];

          if (this.inputType === 'list') {
            this.$set(l_input_list_value, this.dataSource, newval);
          } else {
            this.$set(l_input_value, this.dataSource, newval);
          }
        } else {
          this.l_input = newval;
        }
      }
    },
    options() {
      let campaigns = JSON.parse(JSON.stringify(this.selected_campaigns));
      this.enableTree = campaigns.length === app.auth.user.data_campaigns.length;
      if (this.enableCampaignOptionIfHasPermission.length > 0) {
        campaigns = campaigns.map((cp) => {
          let aux = cp;
          aux['__enabled'] = app.auth.user.hasPermission(this.enableCampaignOptionIfHasPermission, [cp[this.optionValue]]);
          return aux;
        });
      }
      return campaigns;
    },
    allOptionCampaigns() {
      return this.allOptionValue ? this.allOptionValue : this.options.map(o => o.id).join();
    }
  },
  data() {
    return {
      optionValue: 'campaign_id',
      optionLabel: 'campaign_name',
      parentId: "parent_campaign_id",
      childId: "id",
      enableTree: false,
      l_input: null
    }
  },
  methods: {
    validate_input() {
      return this.$refs[`ks-campaign-single-select-field-${this._uid}`]?.validate_input();
    },
    selectorMounted(evt) {
      setTimeout(() => {
        if (!this.input) { //take value of the datapovider
          if (typeof this.defaultValue !== 'undefined') { //take the defaultValue
            this.input = this.defaultValue;
          } else if (this.selectCampaignIfSingleCampaignMode) { //take by default Active Campaign value
            this.input = typeof app.activeMultiCampaigns !== 'undefined' && app.activeMultiCampaigns.length === 1 ? app.activeMultiCampaigns[0].id : null;
          }
          if (this.setToDefaultCampaign) {
            this.input = app.auth.user.default_campaign_id;
          }
        }
        if (this.dataSource !== null) this.$parent.data_provider_ref.inputs[this.dataSource] = this;
        this.$emit('onMounted', this);
      }, 100)
    },
    /*Proxy Events*/
    onKeyPress(evt) {
      this.$emit('onKeyPress', this);
    },
    onBlur(evt) {
      this.$emit('onBlur', this);
    },
    onFocus(evt) {
      this.$emit('onFocus', this);
    },
    onClick(evt) {
      this.$emit('onClick', this);
    },
    onChange(evt) {
      this.$emit('onChange', this);
    },
    onNewClick(evt) {
      this.$emit('onNewClick', this);
    },
    onAllClick(evt) {
      this.$emit('onAllClick', this);
    }
  }
}
</script>
